import React, {useState} from "react";

import '../../styles/Image.css';

const Image = ({ id, image, nftName }) => {
  const [isHidden, setIsHidden] = useState(true);
  
  const onImageClick = () => {
    setIsHidden(false);
  };

  const onCloseClick = () => {
    setIsHidden(true);
  };

  return (
    <>
      <svg className="egg-image" onClick={onImageClick} xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" width="122.687" height="164.936" viewBox="0 0 122.687 164.936">
          <defs>
              <radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
                  <stop offset="0" stopColor="#fff"/>
                  <stop offset="0.724" stopColor="#cbcbcb" stopOpacity="0.651"/>
                  <stop offset="1" stopColor="#b1b1b1" stopOpacity="0.69"/>
              </radialGradient>
              <pattern id={"pattern"+id} preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 640 571">
                  <image className="inner-img" width="640" height="571" xlinkHref={image}/>
              </pattern>
          </defs>
          <g id="Group_2" data-name="Group 2" transform="translate(-880 -290.616)">
              <path id="inner" d="M61.343-133.616c33.877,0,61.343,80.049,61.343,110.251S95.216,31.32,61.343,31.32,0,6.837,0-23.365,27.463-133.616,61.343-133.616Z" transform="translate(880 424.232)" fill="url(#radial-gradient)"/>
              <path id="outer2" d="M61.343-133.616c33.877,0,61.343,80.049,61.343,110.251S95.216,31.32,61.343,31.32,0,6.837,0-23.365,27.463-133.616,61.343-133.616Z" transform="translate(880 424.232)" fill={"url(#pattern"+id+")"}/>
          </g>
      </svg>
      <div className={isHidden ? 'd-none' : ''}>
          <div className="img-modal">
              <span className="img-modal-close" onClick={onCloseClick}>&times;</span>
              <img className="img-modal-content" src={image} alt="NFT Egg" />
              <div className="img-modal-caption">{nftName}</div>
          </div>
      </div>
    </>
  )
};

export default Image;